import { ClassValue } from 'clsx';
import cn from '../../app/utils/cn';
import Logo from './Logo';

type BrandLockupOrientation = 'horizontal' | 'stacked';

interface IBrandLockupProps {
  className?: ClassValue;
  markClassName?: ClassValue;
  wordmarkClassName?: ClassValue;
  orientation?: BrandLockupOrientation;
  asHeading?: boolean;
}

export default function BrandLockup({
  className,
  markClassName,
  wordmarkClassName,
  orientation = 'horizontal',
  asHeading = false,
}: IBrandLockupProps) {
  const isStacked = orientation === 'stacked';
  const Wordmark = asHeading ? 'h1' : 'span';

  return (
    <div
      className={cn(
        'flex items-center',
        isStacked ? 'flex-col gap-2' : 'flex-row gap-2 md:gap-3',
        className,
      )}
    >
      <Logo
        decorative
        variant={isStacked ? 'mark' : 'micro'}
        className={cn(
          isStacked ? 'h-16 w-16 md:h-20 md:w-20' : 'h-7 w-7',
          markClassName,
        )}
      />

      <Wordmark
        className={cn(
          'tracking-tight whitespace-nowrap',
          isStacked ? 'text-xl md:text-2xl' : 'text-[15px] md:text-base',
          wordmarkClassName,
        )}
      >
        <span className="dark:text-text-primary font-semibold text-green-600">
          Clicker
        </span>{' '}
        <span className="dark:text-text-tertiary font-normal text-green-800">
          Sphere
        </span>
      </Wordmark>
    </div>
  );
}
